import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import SoftBadge from "components/SoftBadge";
import { MoreVertRounded } from "@mui/icons-material";
import { useState } from "react";
import { Menu, MenuItem, ThemeProvider, createTheme } from "@mui/material";
import ConfirmModal from "./confirmModal";
import DeleteModal from "./deleteModal";  
import DummyImage from "assets/images/2665820.jpg"
import { useSelector } from "react-redux";

function DefaultProjectCard({ image, label, title, businessId, action, authors, primary,setRefresh }) {

  const userTheme = useSelector((state) => state.commonSlice.theme);
  const [openMenu, setOpenMenu] = useState(false);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const isDark = userTheme == "dark";

  const darkTheme = createTheme({
    components: {
      MuiMenu: {
        styleOverrides: {
          paper: {
            backgroundColor: isDark ? "#1e1e1e" : "#ffffff", // Dark or Light background color
            color: isDark ? "#ffffff" : "#000000", // Light or Dark text color
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            color: isDark ? "#ffffff" : "#000000", // Text color
            "&:hover": {
              backgroundColor: isDark ? "#333333" : "#eeeeee", // Hover state
            },
            "&.Mui-selected": {
              backgroundColor: isDark ? "#444444" : "#dddddd", // Selected state
              color: isDark ? "#ff9800" : "#1976d2", // Accent color
              "&:hover": {
                backgroundColor: isDark ? "#555555" : "#cccccc", // Hover on selected
              },
            },
          },
        },
      },
    },
  });

  function DarkModeMenu({ openMenu, handleCloseMenu }) {
    return (
      <ThemeProvider theme={darkTheme}>
        <Menu
          anchorEl={openMenu}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={Boolean(openMenu)}
          onClose={handleCloseMenu}
        >
          <MenuItem onClick={()=>{handleCloseMenu(),setShow(true)}}>Mark as default</MenuItem>
          <MenuItem onClick={()=>{handleCloseMenu(),setShow2(true)}}>Delete location</MenuItem>
        </Menu>
      </ThemeProvider>
    );
  }

  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);

  const handleCloseMenu = () => {
    setOpenMenu(false)
  };

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "visible",
        padding: 2,
        height:400
      }}
      className="glassmorphism-card"
    >
      <ConfirmModal show={show} unShow={setShow} businessId={businessId} setRefresh={setRefresh}/>
      <DeleteModal show={show2} unShow={setShow2} businessId={businessId} setRefresh={setRefresh}/>
      <SoftBox position="relative" width="100.25%" shadow="xl" borderRadius="xl" >
        {primary ? <SoftBox
          position="absolute"
          top={-20}
          right={-10}
          zIndex="10"
          p={0.5}
          borderRadius="xl"
          bgcolor="background.paper"
        >
          <SoftBadge color="primary" badgeContent={"primary"} />
        </SoftBox> :
          <SoftBox
            position="absolute"
            bottom={-140}
            right={-10}
            zIndex="10"
            p={0.5}
            borderRadius="xl"
            bgColor="background.paper"
          >
            <Card className="glassmorphism-card" p={2}
              aria-controls="notification-menu"
              aria-haspopup="true"
              onClick={handleOpenMenu}
            >
              <MoreVertRounded
                color={isDark?"white":"black"}
              />
            </Card>
          </SoftBox>
        }
        <DarkModeMenu openMenu={openMenu} handleCloseMenu={handleCloseMenu} />
        <CardMedia
          src={image?image:DummyImage}
          component="img"
          title={title}
          sx={{
            width: "100%",
            height: 200,
            margin: 0,
            boxShadow: ({ boxShadows: { md } }) => md,
            objectFit: "cover",
            objectPosition: "center",
          }}
        />
      </SoftBox>
      <SoftBox pt={3} px={0.5}>
        <SoftBox mb={1}>
          <SoftTypography
            variant="button"
            fontWeight="regular"
            textTransform="capitalize"
          >
            {label || 'N/A'}
          </SoftTypography>
        </SoftBox>
        <SoftBox mb={1}>
          {action.type === "internal" ? (
            <SoftTypography
              component={Link}
              to={action.route}
              variant="h5"
              textTransform="capitalize"
            >
              {title || 'N/A'}
            </SoftTypography>
          ) : (
            <SoftTypography
              component="a"
              href={action.route}
              target="_blank"
              rel="noreferrer"
              variant="h5"
              textTransform="capitalize"
            >
              {title || 'N/A'}
            </SoftTypography>
          )}
        </SoftBox>

        <SoftBox display="flex" justifyContent="space-between" alignItems="center">
          {action.type === "internal" ? (
            <SoftButton
              component={Link}
              to={action.route}
              variant="outlined"
              size="small"
              color={action.color}
            >
              {action.label}
            </SoftButton>
          ) : (
            <SoftButton
              component="a"
              href={action.route}
              target="_blank"
              rel="noreferrer"
              variant="outlined"
              size="small"
              color={action.color}
            >
              {action.label}
            </SoftButton>
          )}
        </SoftBox>
      </SoftBox>
    </Card>
  );
}

// Setting default values for the props of DefaultProjectCard
DefaultProjectCard.defaultProps = {
  authors: [],
};

// Typechecking props for the DefaultProjectCard
DefaultProjectCard.propTypes = {
  image: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  action: PropTypes.shape({
    type: PropTypes.oneOf(["external", "internal"]),
    route: PropTypes.string.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "light",
      "dark",
      "white",
    ]).isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  authors: PropTypes.arrayOf(PropTypes.object),
};

export default DefaultProjectCard;
